import React, { useState } from 'react';
import RestUtilities from '../../services/RestUtilities';
import {
  Grid,
  Typography,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { Artist, FeedbackResponse } from '../../@types/api';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { liveArtistsState, toastState } from '../../state/RecoilState';
import { useGetLiveArtists } from '../../hooks/useGetLiveArtists';

const textAreaProps = { my: 1 };

const newFeedbackResponse: FeedbackResponse = {
  artistId: 0,
  bookingId: 0,
  clientId: 0,
  artistName: '',
  artistText: '',
  responseId: 0,
  firstName: '',
  surname: '',
  keepAnon: false,
  serviceText: '',
  eventDate: new Date(),
  recommendArtist: false,
  recommendMFS: false,
};

const formControlSxProps = { mr: 1, minWidth: '210px' };

const CreateCustomTestimonial = () => {
  const setToast = useSetRecoilState(toastState);
  const artists = useRecoilValue(liveArtistsState);
  const [feedbackResponse, setFeedbackResponse] =
    useState<FeedbackResponse>(newFeedbackResponse);
  const [artistId, setArtistId] = useState<number>(-1);
  const [bookingId, setBookingId] = useState<string>('');
  const [clientName, setClientName] = useState<string>('');
  useGetLiveArtists();

  const handleArtistChange = (event: SelectChangeEvent<unknown>) => {
    setArtistId(Number(event.target.value));
  };

  const process = async () => {
    const data = {
      feedbackResponse: {
        ...feedbackResponse,
        bookingId: bookingId ? Number(bookingId) : 0,
        artistId: artistId,
      } as FeedbackResponse,
      useServiceText: false,
      useArtistText: true,
      frontPageOk: false,
      inviteClientToGoogleReview: false,
      clientName,
    };
    var res = await RestUtilities.post(
      'api/feedback/AddCustomTestimonial',
      data
    );
    if (res.ok) {
      setToast('Testimonial Added');
    } else {
      setToast('Testimonial Failed');
    }
  };

  const artistName = () => {
    const selected = artists.find((a: Artist) => a.artistId === artistId) as
      | Artist
      | undefined;
    return !!selected ? selected.artistName : '';
  };

  const isValid = artistId > 0 && !!clientName && !!feedbackResponse.artistText;
  return (
    <Box>
      <>
        <Typography variant='h5' color='primary'>
          Create New Testimonial
        </Typography>
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <FormControl sx={formControlSxProps}>
              <TextField
                required
                id='bookingId'
                label='BookingId (if known)'
                value={bookingId}
                type='number'
                onChange={(event) => setBookingId(event.target.value)}
                size='small'
              />
            </FormControl>
            <FormControl size='small' sx={formControlSxProps}>
              <InputLabel id='artist-select-label'>Artist</InputLabel>
              <Select
                labelId='artist-select-label'
                id='artist-select'
                label='Artist'
                value={artistId}
                onChange={handleArtistChange}
                variant='outlined'
                size='small'
              >
                <MenuItem value={-1}>-- Select --</MenuItem>
                {artists.map((a: Artist) => (
                  <MenuItem value={a.artistId} key={a.artistId}>
                    {a.artistName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={formControlSxProps}>
              <TextField
                required
                id='clientName'
                label='ClientName (if no booking ID)'
                value={clientName}
                onChange={(event) => setClientName(event.target.value)}
                size='small'
                sx={{ width: '300px' }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              multiline
              id='artist-comment'
              label={`Comments on ${artistName()}`}
              value={feedbackResponse.artistText ?? ''}
              fullWidth
              margin='normal'
              onChange={(e) => {
                setFeedbackResponse({
                  ...feedbackResponse,
                  artistText: e.currentTarget.value,
                });
              }}
              InputProps={{
                rows: 3,
                multiline: true,
                inputComponent: 'textarea',
              }}
              variant='outlined'
              sx={textAreaProps}
            />
          </Grid>
          <Grid item xs={12}>
            <Box>
              <Button
                variant='contained'
                color='primary'
                disabled={!isValid}
                onClick={process}
              >
                Add testimonial
              </Button>
            </Box>
          </Grid>
        </Grid>
      </>
    </Box>
  );
};
export default CreateCustomTestimonial;
